import { FEATURE_NAME } from './consts';

export const CREATE_BRAND = `${FEATURE_NAME}/CREATE_BRAND`;
